import Tickets from "./Tickets.view";

export default Tickets;
